<sl-form-view [mainPageActions]="currentActions">
    @if (!!recordSummary()) {
        <mat-card>
            <mat-card-content class="container ml-0">
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">
                            {{ 'Address.Title' | translate }}
                            @if (canEditAddress()) {
                                <button class="edit" mat-icon-button (click)="openAddressDialog()">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            }
                        </h2>
                        <p class="formatted-address">{{ recordSummary()!.formattedAddress }}</p>
                    </div>

                    @if (recordSummary()!.correspondenceFormattedAddress) {
                        <div class="col-xl-4 col-lg-6 col-md-12 mb-5">
                            <h2 class="summary">{{ 'Address.CorrespondenceAddressTitle' | translate }}</h2>
                            <p class="formatted-address">{{ recordSummary()!.correspondenceFormattedAddress }}</p>
                        </div>
                    }

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'Contact.Title' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Shareholders.Id' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.id }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Shareholders.Type' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.shareholderTypeDescription }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Shareholders.OwnershipType' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.ownershipTypeDescription }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Address.DeliveryMethodName' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.deliveryMethodName }}</span>
                            </div>
                        </div>

                        @if (recordSummary()!.email) {
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'Contact.Email' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ recordSummary()!.email }}</span>
                                </div>
                            </div>
                        }

                        @if (recordSummary()!.mobileNumber) {
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'Contact.MobileNumber' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ recordSummary()!.mobileNumber }}</span>
                                </div>
                            </div>
                        }

                        @if (recordSummary()!.mobileNumber) {
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'General.Language' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ recordSummary()!.languageName }}</span>
                                </div>
                            </div>
                        }
                    </div>

                    @if (!recordSummary()!.shareholderTypeIsBusiness) {
                        <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                            <h2 class="summary">{{ 'Shareholders.PersonalInformation' | translate }}</h2>
                            @if (recordSummary()!.nationalityCountryName) {
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="font-weight-light">{{ 'Shareholders.CountryOfNationality' | translate }}</label>
                                    </div>
                                    <div class="col-md-8">
                                        <span>{{ recordSummary()!.nationalityCountryName }}</span>
                                    </div>
                                </div>
                            }
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'General.DateOfBirth' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ recordSummary()!.dateOfBirth | localizedDate: 'shortDate' }}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'Shareholders.IsManagementOrBoardOfDirectors' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>
                                        {{
                                            recordSummary()!.isManagementOrBoardOfDirectors
                                                ? ('General.Yes' | translate)
                                                : ('General.No' | translate)
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }

                    @if (recordSummary()!.shareholderTypeIsBusiness) {
                        <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                            <h2 class="summary">{{ 'Shareholders.CompanyInformation' | translate }}</h2>
                            @if (recordSummary()!.companyLegalFormDescription) {
                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="font-weight-light">{{ 'Shareholders.LegalForm' | translate }}</label>
                                    </div>
                                    <div class="col-md-8">
                                        <span>{{ recordSummary()!.companyLegalFormDescription }}</span>
                                    </div>
                                </div>
                            }
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="font-weight-light">{{ 'Shareholders.CompanyActivity' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <span>{{ recordSummary()!.companyActivityTitle }}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 class="summary">{{ 'ShareStatistics.SharesBalance' | translate }}</h2>
                        <sl-share-info [id]="recordId()!" [type]="ShareInfoTypeEnum.Shareholder" />
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    }
</sl-form-view>
